import React, { useEffect, useMemo, useState } from 'react'
import Card from '../../../components/Card'
import DataTable from 'react-data-table-component'
import { Spinner } from 'react-bootstrap'
import TransaksiService from '../../../services/transaksi/TransaksiService'

const ExpandableComponentPnbpReadyBilling = ({ data }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [listDetail, setListDetail] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchDetail = async () => {
            setLoading(true)
            try {
                const response = await transaksiService.listPnbpDetil(data.idPnbp, 0, 10)
                setListDetail(response.data.data)
            } catch (error) {
                setListDetail([])
            }
            setLoading(false)
        }
        fetchDetail()
    }, [transaksiService, data])

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju']
        },
        {
            name: 'Kode Tarif',
            cell: row => row['kodeTarif']
        },
        {
            name: 'Volume',
            cell: row => row['volume']
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Tarif',
            cell: row => row['totalTarif']
        }
    ]

    return (
        <>
            <Card>
                <Card.Body>
                    <div className="header-title">
                        <h4 className="card-title">Detail PNBP</h4>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {(loading && <Spinner />)}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#7c878dff', 'color': 'white' } } }}
                            columns={columns}
                            data={listDetail}
                            highlightOnHover
                            pagination
                        />
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default ExpandableComponentPnbpReadyBilling